import { setLocale } from 'yup';
import type { Message } from 'yup/lib/types';
import i18next from 'i18next';

export const validationLang: Record<any, Message> = {
  shouldBeNumber: (p) => i18next.t('validation.shouldBeNumber', p),
  notEmpty: (p) => i18next.t('validation.notEmpty', p),
  required: (p) => i18next.t('validation.required', p),
  email: (p) => i18next.t('validation.email', p),
  emailShouldMatch: (p) =>
    i18next.t('validation.emailShouldMatch', p),
  phoneNumber: (p) => i18next.t('validation.phoneNumber', p),
  passwordShouldMatch: (p) =>
    i18next.t('validation.passwordShouldMatch', p),
  url: (p) => i18next.t('validation.url', p),
  shouldContainNumber: (p) =>
    i18next.t('validation.shouldContainNumber', p),
  shouldContainLetter: (p) =>
    i18next.t('validation.shouldContainLetter', p),
  dateTypeError: (p) => i18next.t('validation.dateTypeError', p),
  olderThen: (p) => i18next.t('validation.olderThen', p),
  shouldNotContainSpace: (p) =>
    i18next.t('validation.shouldNotContainSpace', p),
  creditCardNumber: (p) =>
    i18next.t('validation.creditCardNumber', p),
  creditCardExpirationDate: (p) =>
    i18next.t('validation.creditCardExpirationDate', p),
  creditCardCvc: (p) => i18next.t('validation.creditCardCvc', p),
};

setLocale({
  mixed: {
    required: (p) => i18next.t('validation.required', p),
  },
  string: {
    email: (p) => i18next.t('validation.email', p),
    min: (p) => i18next.t('validation.string.min', p),
    max: (p) => i18next.t('validation.string.max', p),
    matches: (p) => i18next.t('validation.string.alphanum', p),
    url: (p) => i18next.t('validation.url', p),
  },
  array: {
    min: (p) => i18next.t('validation.array.min', p),
  },
  number: {
    min: (p) => i18next.t('validation.number.min', p),
    max: (p) => i18next.t('validation.number.max', p),
    positive: (p) => i18next.t('validation.number.positive', p),
  },
  date: {
    min: (p) => i18next.t('validation.date.min', p),
    max: (p) => i18next.t('validation.date.max', p),
  },
});
